module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-1-5fd1a821dce91a42137b13a22ae7c6ee.jpg";